import Masonry from 'masonry-layout/dist/masonry.pkgd.min.js';
import ImagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js';

class Hamburger {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Declare and initialize
        let $grid = $('.ll-masonry.grid').masonry({
            'itemSelector':    '.grid-item',
            'columnWidth':     '.grid-spacer',
            'percentPosition': true,
        });

        // Run the layout after images have loaded
        $grid.imagesLoaded().progress(function () {
            $grid.masonry('layout')
        });

    }
}

export default Hamburger;